import { CustomModalCell } from '../../components/custom-modal-cell';
import { OrdersModalCell } from './components/orders-modal-cell';

export const FORM_NAME = 'orders-ways-form';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const ADMIN_ROLE_NUMBER = 1;

export const TABLE_COLUMNS_NAMES = [
	{ id: 'title', width: '300px' },
	{ id: 'value', customComponent: CustomModalCell, subCustomComponent: OrdersModalCell },
];

export const ADMIN_TABLE_ROWS_NAMES = {
	orderGroupTitle: 'Группа заказов',
	autopark: 'Автопарк',
	transport: 'Транспорт',
	maxWeight: 'Грузоподъемность авто',
	maxVolume: 'Объем кузова авто',
	volumeRate: 'Коэффициент объема груза',
	weightRate: 'Коэффициент массы груза',
	distance: 'Протяжённость',
	totalTime: 'Суммарное время',
	sumCost: 'Стоимость груза',
	sumWeight: 'Масса',
	sumVolume: 'Объем',
	timeWindowFrom: 'Начало рейса',
	timeWindowTo: 'Конец рейса',
	link: 'Ссылка на карту маршрута',
};

export const TABLE_ROWS_NAMES = {
	orderGroupTitle: 'Группа заказов',
	autopark: 'Автопарк',
	transport: 'Транспорт',
	maxWeight: 'Грузоподъемность авто',
	maxVolume: 'Объем кузова авто',
	weightRate: 'Коэффициент массы груза',
	volumeRate: 'Коэффициент объема груза',
	distance: 'Протяжённость',
	totalTime: 'Суммарное время',
	sumCost: 'Стоимость груза',
	sumWeight: 'Масса',
	sumVolume: 'Объем',
	timeWindowFrom: 'Начало рейса',
	timeWindowTo: 'Конец рейса',
	link: 'Ссылка на карту маршрута',
};

export const DATE_FORMAT = 'DD.MM.YYYY';

export const FIELDS_FOR_VALIDATE = ['group_id', 'name'];

export const REQUIRED_FIELDS_FOR_VALIDATE = ['group_id', 'name'];
